export default {
  url: {
    CenterName: 'Center Name',
    CenterCode: 'Center Code',
    ServiceName: 'Service Name',
    ServiceCode: 'Service Code',
    ModuleName: 'Module Name',
    ModuleCode: 'Module Code',
    TypeName: 'Type Name',
    AccessUrl: 'Access Url',
    AccessMethod: 'Access Method',
    ClassMethod: 'Class Method',
    ClassName: 'Class Name',
    MenuId: 'Menu Id',
    MenuName: 'Menu Name',
    FunctId: 'Funct Id',
    FunctName: 'Funct Name',
    MatchPath: 'Match Path',
    AccessAddress: 'Access Address',
    TypeMethod: 'Type Method'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/en/base/url.js